import {
  ClearRounded,
  EditRounded,
  LockResetRounded,
} from "@mui/icons-material";
import { IconButton, Tooltip } from "@mui/material";
import React from "react";
import { useTranslation } from "react-i18next";
import { controller, Server } from "../../api/Server";

const ActionComp = ({
  param,
  access,
  handleAddEdit,
  setAlert,
  setTblData,
  setUpdateUserId,
  setShowResetPassForm,
}) => {
  const { t } = useTranslation();

  const handleDlt = (id) => {
    setAlert({
      isOpen: true,
      type: "confirmation",
      title: t("areYouSure"),
      subTitle: t("userDltUser"),
      onConfirm: () => {
        const onComplete = (res) => {
          if (res.status === 200) {
            setAlert({
              isOpen: true,
              type: "success",
              title: t("dltSuccessTitle"),
              subTitle: res.msg,
            });
            setTblData((x) => [...x.filter((j) => j.id !== res.result.id)]);
          } else
            setAlert({
              isOpen: true,
              type: "error",
              title: t("error"),
              subTitle: res.msg,
            });
        };
        Server(controller.User).Delete(id, onComplete);
      },
    });
  };

  const handleShowResetPassForm = (id) => {
    setUpdateUserId(id);
    setShowResetPassForm(true);
  };

  return (
    <div className="bs-secondary br-8 w-fit">
      {access.isHaveEditAccess && (
        <>
          <Tooltip arrow title={t("edit")}>
            <IconButton
              onClick={() => handleAddEdit(param)}
              size="small"
              color="primary"
              className="mr-5 p-5"
            >
              <EditRounded className="fs-18 m-2" />
            </IconButton>
          </Tooltip>
          <Tooltip arrow title={t("resetPassword")}>
            <IconButton
              onClick={() => handleShowResetPassForm(param.id)}
              size="small"
              color="primary"
              className="mr-5 p-5"
            >
              <LockResetRounded className="fs-18 m-2" />
            </IconButton>
          </Tooltip>
        </>
      )}

      {access.isHaveDeleteAccess && (
        <Tooltip arrow title={t("delete")}>
          <IconButton
            onClick={() => handleDlt(param.id)}
            size="small"
            color="error"
            className="mr-5 p-5"
          >
            <ClearRounded className="fs-18 m-2" />
          </IconButton>
        </Tooltip>
      )}
    </div>
  );
};

export default ActionComp;
